<template>
	<h-disclosure-button>
		<slot></slot>
	</h-disclosure-button>
</template>
